<template>

    <div class="nav-wrapper">
        <ul class="nav-drop">
            <template v-if="type!=='normal'">
                
                <li @click="menuLink(menus[0][0].menu,'all')">{{menus[0][0].menu}}</li>
                <template v-for="(menu, index) in menus[0]" :key="index">
                    <li @click="menuLink(menu.menu,menu.name)">{{menu.title}}</li>
                </template>
                <template v-for="(menu, index) in menus" :key="index">
                    <li v-if="index>0" @click="menuLink(menu.menu,menu.name,1)">{{menu.title}}</li>
                </template>
            </template>
            
            <template v-else>
                <!--게시판구조 아닌 메뉴-->                        
                <li @click="linkitem(menus[1].name,menus[1].routename)">{{menus[1].title}}</li>
                 <template v-for="(menu, index) in menus" :key="index">
                    <li @click="linkitem(menu.name,menu.menu)" v-if='index>0'>{{menu.title}}</li>
                </template>
                <!--<template v-for="(menu, index) in menus" :key="index">
                    <li v-if="index>0" @click="menuLink(menu.menu,menu.name,1)">{{menu.title}}</li>
                </template> -->
            </template>
        </ul>
    </div>
</template>
<script>
import { updateMenu } from '@/utils/menu.js'
export default {
    props:[
        'menus',
        'type'
    ],
    methods:{
        menuLink(menu, document,otherlink)
        {
            let current = this.$store.state.menu.menus.find(
                (item)=>item.title === menu
            );
            console.log(current);

            updateMenu(current.name,document, this.$store);
             if(otherlink ===1)
                {
                    this.$router.push({
                        path: "/main/community/"+ document
                        });
                }else{
                    this.$router.push({
                        path: "/main/community/" + current.name+"/"+document
                    });
                }

            this.$emit("close");
        },
        //게시판 아닌 메뉴 링크
        linkitem(path, activemenu)
        {
            this.$router.push({name:path});
            this.$store.commit("menu/setActiveMenu", activemenu);

            this.$emit("close");
        }
    }
}
</script>
<style lang="scss" scoped>
.nav-wrapper{
    width:100%;
    .nav-drop{
        text-indent: 20px;
        display: inline-block;
        vertical-align: top;
        height: 393px;
        li:first-child {
            font-family: malgungothic, sans-serif;
            font-weight: 600;
            letter-spacing: -1px;
            font-size: 14px;
            margin-bottom: 30px;
            margin-top: 20px;
        }
        li {
            font-family: YoonGothicPro,Gulim,sans-serif;
            font-size: 12px;
            margin-bottom: 17px;
            cursor:pointer;
        }
    }
}

</style>
